import Vue from 'vue';
import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3b2d0a38&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports;
(function(clientMoundId) {

    if (
      (process.env.NODE_ENV === 'development') &&
      (module.hot.status() === 'apply')
    ) {
      // No need to manually mount component during hot-reload cycle
      return;
    }

    const app = new Vue({
      render: function(h) {
        return h(
          'div',
          null,
          [
            h(component.exports)
          ]
        );
      }
    });

    app.$mount('#' + clientMoundId);
  })("__viddsee")